import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Button } from '../Button';
// The floating bar a page saves and discards its edits from. The app places it (bottom centre of
// the page) and decides when it shows; ⌘S / Ctrl+S saves while it is mounted.
export const SaveBar = ({ message, problem, saveLabel, discardLabel, saving = false, onDiscard, onSave }) => {
    const canSave = !problem && !saving;
    useEffect(() => {
        const onKey = (event) => {
            if ((event.metaKey || event.ctrlKey) &&
                event.key.toLowerCase() === 's') {
                event.preventDefault();
                if (canSave)
                    onSave();
            }
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [canSave, onSave]);
    return (_jsxs("div", { className: "pointer-events-auto flex items-center gap-3 rounded-xl border border-solid border-neutral-200 bg-white py-2.5 pl-5 pr-2.5 font-roobert shadow-lg", children: [_jsx("span", { className: "size-2 rounded-full bg-amber-400" }), _jsx("span", { className: "text-sm text-neutral-800", children: message }), problem ? (_jsx("span", { className: "text-sm text-red-500", children: problem })) : null, _jsx(Button, { type: "button", variant: "secondary", size: "sm", disabled: saving, onClick: onDiscard, children: discardLabel }), _jsxs(Button, { type: "button", variant: "primary", size: "sm", loading: saving, disabled: !!problem, onClick: onSave, children: [saveLabel, _jsx("kbd", { className: "ml-1 rounded bg-white/20 px-1 text-xs", children: "\u2318S" })] })] }));
};
